(function () {
  var root = document.getElementById('td-loader');
  if (!root) return;

  var homeBannerOnly = root.hasAttribute('data-td-home-banner-only');
  var homeCleanup = function () {};

  var wavePath = document.getElementById('td-loader-wave-path');
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var state = { level: 0, target: 0, phase: 0, done: false };
  var lastTime = performance.now();
  var maxBlockingTime = 4200;

  function setTarget(pct) {
    state.target = Math.max(state.target, Math.min(100, pct));
  }

  function buildWavePath(level, phase) {
    var size = 120;
    var amp = prefersReducedMotion ? 0 : size * 0.032;
    var wavelength = size / 1.4;
    var baseY = size - (size * level) / 100;
    var steps = 24;
    var d = 'M0,' + size + ' L0,' + baseY.toFixed(2) + ' ';
    for (var i = 0; i <= steps; i++) {
      var x = (size / steps) * i;
      var y = baseY + Math.sin((x / wavelength) * Math.PI * 2 + phase) * amp;
      d += 'L' + x.toFixed(2) + ',' + y.toFixed(2) + ' ';
    }
    d += 'L' + size + ',' + size + ' Z';
    return d;
  }

  function finish() {
    if (state.done) return;
    state.done = true;
    homeCleanup();
    if (homeBannerOnly) {
      root.setAttribute('data-td-loader-done', '');
      setTimeout(function () { if (root.parentNode) root.parentNode.removeChild(root); }, 320);
      return;
    }
    setTimeout(function () {
      root.setAttribute('data-td-loader-done', '');
      setTimeout(function () {
        if (root.parentNode) root.parentNode.removeChild(root);
      }, 320);
    }, 180);
  }

  function tick(now) {
    if (state.done) return;
    var dt = Math.min(now - lastTime, 48);
    lastTime = now;

    var eased = state.level + (state.target - state.level) * Math.min(1, dt / 260);
    state.level = Math.max(state.level, Math.min(state.target, eased));
    if (state.target >= 100 && state.level > 99.5) state.level = 100;
    if (!prefersReducedMotion) state.phase += dt * 0.0016;

    if (wavePath) wavePath.setAttribute('d', buildWavePath(state.level, state.phase));

    if (state.level >= 100) {
      finish();
      return;
    }
    requestAnimationFrame(tick);
  }

  setTarget(12);

  function onDomReady() {
    setTarget(55);
    if (homeBannerOnly) {
      watchHomeBanner();
      return;
    }
    var hasCriticalHero = watchCriticalVisual();

    if (!hasCriticalHero) {
      finishWhenStorefrontIsReady();
    }

    // Never let third-party scripts, app iframes, or non-critical resources keep
    // the storefront covered indefinitely.
    setTimeout(finish, maxBlockingTime);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDomReady, { once: true });
  } else {
    onDomReady();
  }

  function pollResources() {
    if (state.done) return;
    var total =
      document.images.length +
      document.scripts.length +
      document.querySelectorAll('link[rel="stylesheet"]').length;
    if (total > 0 && window.performance && performance.getEntriesByType) {
      var loaded = performance.getEntriesByType('resource').length;
      setTarget(20 + Math.min(1, loaded / total) * 68);
    }
    setTimeout(pollResources, 180);
  }
  if (!homeBannerOnly) pollResources();

  function finishWhenStorefrontIsReady() {
    var main = document.querySelector('main');
    if (!main || !main.firstElementChild || main.getBoundingClientRect().height <= 0) return;

    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var fontsTimeout = new Promise(function (resolve) {
      setTimeout(resolve, 700);
    });

    Promise.race([fontsReady, fontsTimeout]).then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (main.getBoundingClientRect().height > 0) setTarget(100);
        });
      });
    });
  }

  function watchHomeBanner() {
    // Use the rendered picture's selected resource; never create another request.
    var banner = document.querySelector('main [data-td-image-preload]');
    var image = banner && banner.querySelector('img.slide__image');
    var settled = false;
    var timer = setTimeout(complete, maxBlockingTime);
    function complete() {
      if (settled) return;
      settled = true;
      finish();
    }
    function ready() {
      if (settled || !image.complete) return;
      if (!image.naturalWidth) { complete(); return; }
      if (image.decode) {
        image.decode().then(complete, complete);
      } else {
        complete();
      }
    }
    homeCleanup = function () {
      clearTimeout(timer);
      if (image) {
        image.removeEventListener('load', ready);
        image.removeEventListener('error', complete);
      }
    };
    if (!image) { complete(); return; }
    image.addEventListener('load', ready);
    image.addEventListener('error', complete);
    ready();
  }

  function watchCriticalVisual() {
    var heroVideo = document.querySelector('main video[data-testid^="hero-"]');
    if (!heroVideo || !heroVideo.poster) return false;

    var settled = false;
    var poster = new Image();

    function onPosterReady() {
      if (settled) return;
      settled = true;
      setTarget(100);
    }

    heroVideo.addEventListener('loadeddata', onPosterReady, { once: true });
    poster.addEventListener('load', function () {
      if (poster.decode) {
        poster.decode().then(onPosterReady, onPosterReady);
      } else {
        onPosterReady();
      }
    }, { once: true });

    if ('fetchPriority' in poster) poster.fetchPriority = 'high';
    poster.src = heroVideo.poster;

    if (poster.complete && poster.naturalWidth > 0) {
      if (poster.decode) {
        poster.decode().then(onPosterReady, onPosterReady);
      } else {
        onPosterReady();
      }
    }

    return true;
  }

  function onFullyLoaded() {
    setTarget(100);
  }
  if (!homeBannerOnly && document.readyState === 'complete') {
    onFullyLoaded();
  } else if (!homeBannerOnly) {
    window.addEventListener('load', onFullyLoaded, { once: true });
  }

  requestAnimationFrame(tick);
})();
